import * as React from 'react';
import { Card, CardBody, CardHeader, Col, Row } from 'reactstrap';
import { useAppDispatch, useAppSelector } from '../../hooks';
import { Afr, getSelectedAfr, resetState } from '../../redux/AfrSlice';
import { resetConceptState } from '../../redux/ConceptSlice';
import { Affiliation, Entity, getSelectedEntity, resetEntityState, hasNameChange, createNameChangeEntry } from '../../redux/EntitySlice';
import { EntityReference, getDBAText, selectEntities } from '../../redux/EntitiesSlice';
import { setTaxonomyType } from '../../redux/MiscSlice';
import { TaxonomyTypeEnum } from '../../redux/TaxonomyVersionSlice';
import AfrReportsCore from '../AfrCore/AfrReportsCore';
import AfrSelector from '../feature/AfrSelector';
import PublicEntitySelector from '../feature/PublicEntitySelector';
import Page from '../Page';

const SubmittedReports = (props: any) => {

    const dispatch = useAppDispatch();
    const afr: Afr | null = useAppSelector(getSelectedAfr);
    const selectedEntity: Entity | null = useAppSelector(getSelectedEntity);
    var entityList: EntityReference[] = useAppSelector(selectEntities);

    const getNameChangeText = function (entity : Entity) : string {
        var result: string = "";
        if (entity.references) {
            entity.references.map(x => (x.type.indexOf("nameChange") > 0) ? result = createNameChangeEntry(x) : "");
        }
        return result;
    }
    const matchesAffiliation = function(entity: Entity | null, afr: Afr | null) : boolean {
        if (!entity || !afr || !afr.owner) {
            return false;
        }
        var eCode: string = afr.owner.code; 

        var affToMatch: Affiliation | null = entity.affiliation;
        while (affToMatch) {
            if (affToMatch.affiliate.code === eCode) {
                return true;
            }
            affToMatch = affToMatch.prior;
        }
        return false;
    }
    React.useEffect(() => {
        // We will need to refactor this component so the taxonomyh type can be passed in instead of assumed. That's for 3.1
        dispatch(setTaxonomyType(TaxonomyTypeEnum.AFR));
        // reset the states when destroying the component
        return function cleanup() {
            console.log("Releasing resources.");
            dispatch(resetState({}));
            dispatch(resetEntityState({}));
            dispatch(resetConceptState({}));
        }
    }, []);

    return (
        <React.Fragment>
            <Page>
                <Row>
                    <Col>
                        <CardHeader
                            style={{
                                color: "white",
                                backgroundColor: "#458BCA",
                                borderRadius: "0px",
                                fontWeight: "initial"
                            }}
                        >Entity: <i>Begin typing the entity name in the field below or use it as a drop-down selector</i></CardHeader>
                        <Card>
                            <CardBody style={{
                                fontSize: ".9rem",
                                margin: "0 auto",
                                width: "94%"
                            }}>
                                <PublicEntitySelector />
                            </CardBody>
                        </Card>
                        <CardHeader
                            style={{
                                color: "white",
                                backgroundColor: "#458BCA",
                                borderRadius: "0px",
                                fontWeight: "initial"
                            }}
                        >AFR Year</CardHeader>
                        <Card>
                            <CardBody style={{
                                fontSize: ".9rem",
                                margin: "0 auto",
                                width: "94%"
                            }}>
                                <AfrSelector publicreports={true} />
                            </CardBody>
                        </Card>
                    </Col>
                    <Col>
                        {afr && (<>
                            {selectedEntity && hasNameChange(selectedEntity) && (
                                <>
                                    <CardHeader
                                        style={{
                                            color: "white",
                                            backgroundColor: "#458BCA",
                                            borderRadius: "0px",
                                            fontWeight: "initial"
                                        }}
                                    >Name Change</CardHeader>
                                    <Card>
                                        <CardBody style={{
                                            fontSize: ".9rem",
                                            margin: "0 auto",
                                            width: "94%"
                                        }}>
                                            <div><span style={{fontWeight:"bolder"}}>{selectedEntity.name}</span>{getNameChangeText(selectedEntity)}</div>
                                        </CardBody>
                                    </Card>
                                </>
                            )}
                            { selectedEntity && afr && afr.owner && matchesAffiliation(selectedEntity, afr) && (
                                <>
                                    <CardHeader
                                        style={{
                                            color: "white",
                                            backgroundColor: "#458BCA",
                                            borderRadius: "0px",
                                            fontWeight: "initial"
                                        }}
                                    >Dependent</CardHeader>
                                    <Card>
                                        <CardBody style={{
                                            fontSize: ".9rem",
                                            margin: "0 auto",
                                            width: "94%"
                                        }}>
                                            <div><span style={{ fontWeight: "bolder" }}>{selectedEntity.name}</span> is a {selectedEntity.districtDependency.toLowerCase()} {selectedEntity.districttype} of {afr.owner.name}. Its Financial Information is included in the Affiliated Entities Section of the primary Annual Financial Report.</div>
                                        </CardBody>
                                    </Card>
                                </>
                            )}
                            {selectedEntity && selectedEntity.doingBusinessAs && (
                                <>
                                    <CardHeader
                                        style={{
                                            color: "white",
                                            backgroundColor: "#458BCA",
                                            borderRadius: "0px",
                                            fontWeight: "initial"
                                        }}
                                    >Doing Business As</CardHeader>
                                    <Card>
                                        <CardBody style={{
                                            fontSize: ".9rem",
                                            margin: "0 auto",
                                            width: "94%"
                                        }}>
                                            <div><span style={{ fontWeight: "bolder" }}>{selectedEntity.name}</span>{getDBAText(entityList,selectedEntity,afr)}</div>
                                        </CardBody>
                                    </Card>
                                </>
                            )}
                            <CardHeader
                                style={{
                                    color: "white",
                                    backgroundColor: "#458BCA",
                                    borderRadius: "0px",
                                    fontWeight: "initial"
                                }}
                            >Choose Report</CardHeader>
                            <Card>
                                <CardBody style={{
                                    fontSize: ".9rem",
                                    margin: "0 auto",
                                    width: "94%"
                                }}>
                                    <AfrReportsCore publicreports={true} taxonomyType={TaxonomyTypeEnum.AFR} />
                                </CardBody>
                            </Card> </>)}
                    </Col>
                </Row>
            </Page>
        </React.Fragment>  
    );
}

export default SubmittedReports;